import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

const styles = theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #e0e0e0',
        marginBottom: theme.spacing(2)
    },
    chip: {
        marginLeft: theme.spacing(1),
        //marginBottom: theme.spacing.unit * 1,
        minWidth: 60,
        whiteSpace: 'pre-wrap',
        marginBottom: theme.spacing(0.5)
    },
    singleChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    linkChip: {
        cursor: 'pointer',
        background: theme.palette.primary[500],
        color: 'white',
        '&:hover': {
            //background: "#f5f5f5",
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'
        }
    },
    confirmedChip: {
        background: '#43a047',
        color: 'white'
    },
    question: {
        fontWeight: 400,
        paddingLeft: 0
    },
    section1: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    section2: {
        margin: theme.spacing(2)
    },
    section3: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    titleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(1) + 'px solid ' + theme.palette.primary[500],
        borderBottom: '1px solid #e0e0e0'
    },
    mainTitleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(2) + 'px solid ' + theme.palette.primary[700],
        borderBottom: '1px solid #e0e0e0',
        background: theme.palette.primary[500]
    },
    statusSection: {
        margin: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`
    },
    title: {
        fontWeight: 500,
        fontSize: '1.2rem'
    },
    titleInfo: {
        fontWeight: 400,
        fontSize: '1.1rem',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            textAlign: 'right',
            paddingRight: theme.spacing(1) + 'px!important'
        }
    },
    chipWrapper: {
        marginBottom: theme.spacing(1)
    },
    tableCell: {
        padding: `${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    thRowCell: {
        height: 45
    },
    lastRowCell: {
        borderBottom: 'none'
    },
    lastColumnCell: {
        paddingRight: theme.spacing(1) + 'px!important',
        paddingBottom: theme.spacing(0.5) + 'px!important'
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    statusBlue: {
        background: '#f7f7f7',
        border: '1px solid #e0e0e0',
        marginBottom: -1
    },
    statusText: {
        //color: 'white',
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    tableSection: {
        marginBottom: theme.spacing(1)
    },
    formControl: {
        maxWidth: 75
    },
    leftIcon: {
        marginRight: 10,
        marginLeft: -3
    }
})

class Product extends PureComponent {
    render() {
        const { classes, product } = this.props
        const questions = product.questions

        return (
            <div className={classes.root}>
                <div className={classes.titleSection}>
                    <Grid container alignItems="center">
                        <Grid item xs={12} sm={8}>
                            <Typography variant="h5" className={classes.title}>
                                {product.title}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="h6" className={classes.titleInfo}>
                                {product.description}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.section2 + ' ' + classes.tableSection} style={{ marginTop: 4 }}>
                    <Table className={classes.table}>
                        <TableBody>
                            {questions.map((question, key) => {
                                return (
                                    <TableRow key={key}>
                                        <TableCell
                                            component="th"
                                            variant="body1"
                                            className={
                                                classes.tableCell +
                                                ' ' +
                                                classes.question +
                                                ' ' +
                                                (key === questions.length - 1 ? classes.lastRowCell : null)
                                            }
                                        >
                                            {question.title}
                                        </TableCell>
                                        <TableCell
                                            align="right"
                                            className={
                                                classes.tableCell +
                                                ' ' +
                                                classes.lastColumnCell +
                                                ' ' +
                                                (key === questions.length - 1 ? classes.lastRowCell : null)
                                            }
                                        >
                                            {question.answers &&
                                                question.answers.map((answer, answerKey) => {
                                                    return (
                                                        <a href={answer.link} target="_blank" style={{ textDecoration: 'none' }} key={answerKey}>
                                                            <Chip
                                                                className={
                                                                    classes.chip +
                                                                    ' ' +
                                                                    classes.linkChip +
                                                                    ' ' +
                                                                    (answer.confirmed ? classes.confirmedChip : null)
                                                                }
                                                                label={answer.title}
                                                            />
                                                        </a>
                                                    )
                                                })}
                                            {!question.answers && (
                                                <>
                                                    {question.answer.additionalInformation && (
                                                        <Button color="primary" size={'small'}>
                                                            Lisätietoja
                                                        </Button>
                                                    )}
                                                    <Chip
                                                        className={classes.chip + ' ' + (question.answer.confirmed ? classes.confirmedChip : null)}
                                                        label={question.answer.title}
                                                    />
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(Product)
